import { data } from '../../svg/Attach/data';
import { makeIcon } from '../makeIcon';

export const Attach = makeIcon(data, 'attach', 'Attach');

export default Attach;
